export default __webpack_public_path__ + "static/media/dying-flower-illustration.8956f2f9.svg";